import { AlertSearchModel } from '../../models/alert/alertSearch';
import * as AlertModels from '../../models/alert/alert';

export class GetAlertSummary {
  static readonly type = '[Alert] GetAlertSummary';
    constructor() {  }
}

export class GetAlertList {
  static readonly type = '[Alert] GetAlertList';
  constructor(public Search: AlertSearchModel) { }
}

export class GetAlert {
  static readonly type = '[Alert] GetAlert';
  constructor(public AlertId: number) { }
}

export class Refresh {
  static readonly type = '[Alert] Refresh';
  constructor(public Alert: AlertModels.AlertModel) { }
}

export class GetAlertTitleDictionary {
  static readonly type = '[Alert] GetAlertTitleDictionary';
  constructor() { }
}

export class SetAlert {
  static readonly type = '[Alert] SetAlert';
  constructor(public Alert: AlertModels.AlertModel) { }
}

export class SetAlertSearch {
  static readonly type = '[Alert] SetAlertSearch';
  constructor(public Search: AlertSearchModel) { }
}

export class ResetAlertSearch {
  static readonly type = ' [Alert]ResetAlertSearch';
  constructor() { }
}

export class SetAlertListPage {
  static readonly type = 'SetAlertListPage';
  constructor(public Search: AlertSearchModel) { }
}
